// removed by extract-text-webpack-plugin
module.exports = {"materialize-textarea":"AtheleteDesc__materialize-textarea___K7VKU","modal-2463794813":"AtheleteDesc__modal-2463794813___3DSsI","container":"AtheleteDesc__container___1xa0m","signinSection":"AtheleteDesc__signinSection___3finT","signinHeader":"AtheleteDesc__signinHeader___3Ythb","joinUsButtonContainer":"AtheleteDesc__joinUsButtonContainer___1WBSV","signinBody":"AtheleteDesc__signinBody___3lMtz","learnMore":"AtheleteDesc__learnMore___2YNHU"};


//////////////////
// WEBPACK FOOTER
// ./src/components/AtheleteDetails/AtheleteDesc.scss
// module id = 1464
// module chunks = 0